import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../AuthContext';

const NotFound: React.FC = () => {
  const navigate = useNavigate();
  const { currentUser } = useAuth(); // Use currentUser to check authentication status

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4">
      <div className="w-full max-w-md bg-white shadow-lg rounded-lg p-8 text-center">
        <h1 className="text-6xl font-bold text-gray-800 mb-4">404</h1>
        <p className="text-xl text-gray-600 mb-8">Oops! Page Not Found</p>
        <button
          onClick={() => {
            if (currentUser) {
              navigate('/home');
            } else {
              navigate('/'); 
            }
          }}
          className="w-full bg-gradient-to-r from-blue-500 to-blue-600 text-white px-6 py-2 rounded-md hover:bg-gradient-to-l hover:from-blue-600 hover:to-blue-500 transition duration-300"
        >
          Go Back Home
        </button>
      </div>
    </div>
  );
};

export default NotFound;
